import "./press_release_list_module.scss"

